<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">Balance as of 1 January</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">187,073</td>
                            <td class="end font">198,251</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Additions</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">51,600</td>
                            <td class="end font">50,535</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Accretion of interest</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">13,235</td>
                            <td class="end font">13,273</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Payments</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">(53,665)</td>
                            <td class="end font">(56,720)</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Retirement</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">(11,178)</td>
                            <td class="end font">(17,889)</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Exchange adjustments</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">(4,937)</td>
                            <td class="end font">(377)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold" colspan="3">Closing balance as at 31 December
                                <br /> <span class="small">(excluding liabilities of disposal group classified as held for sale)</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">182,128</td>
                            <td class="end font white font-weight-bold">187,073</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Current</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">38,410</td>
                            <td class="end font">42,795</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Non-current</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">143,718</td>
                            <td class="end font">144,278</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">182,128</td>
                            <td class="end font white font-weight-bold">187,073</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">الرصيد كما في 1 يناير</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">187,073</td>
                            <td class="end font">198,251</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">إضافات</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">51,600</td>
                            <td class="end font">50,535</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">فوائد متراكمة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">13,235</td>
                            <td class="end font">13,273</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">دفعات</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">(53,665)</td>
                            <td class="end font">(56,720)</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">استبعادات</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">(11,178)</td>
                            <td class="end font">(17,889)</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">تعديلات صرف عملات أجنبية</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">(4,937)</td>
                            <td class="end font">(377)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold" colspan="3">الرصيد الختامي كما في 31 ديسمبر
                                <br /> <span class="small">(باستثناء موجودات مجموعة الاستبعاد المصنفة كمحتفظ بها لغرض البيع)</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">182,128</td>
                            <td class="end font white font-weight-bold">187,073</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">متداولة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">38,410</td>
                            <td class="end font">42,795</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">غير متداولة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font">143,718</td>
                            <td class="end font">144,278</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">182,128</td>
                            <td class="end font white font-weight-bold">187,073</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>